import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const PopupOption = ({
    onOpenCommentNotLogin,
    onOpenAndCloseOverlayOptions
}) => {
     // __REDUX
     const { currentState } = useSelector(
        (state) => ({ currentState: state.comment })
    );
    const { commentSetting } = currentState;
    // open login iframe
    const onOpenLoginIframe = () =>
        window.parent.postMessage({ openLoginIframe: true }, "*");
    // open register iframe
    const onOpenRegisterIframe = () =>
        window.parent.postMessage({ openRegisterIframe: true }, "*");
    const { t } = useTranslation();
    return (
        <div className='comment__active relative '>
            {/* popup login */}
            <div className='popup__login relative h-[160px] sm:h-[110px]'>
                <div className='overlay bg-[#00000070] absolute w-full h-full '></div>
                <div className='absolute w-full mt-[15px] '>
                    <div className='flex ml-[10px] sm:ml-0 justify-start flex-wrap sm:justify-center gap-[0px] sm:gap-[20px] '>
                        <button
                            onClick={onOpenLoginIframe}
                            className='cursor-pointer mb-[8px] sm:mb-0 min-w-[85%] sm:min-w-0 font-arial font-semibold font-weight-none sm:font-notosans-bold bg-white text-black px-[30px] py-[10px] '>
                            {t('message.overlayInput.login')}
                        </button>
                        <button
                            style={{
                                backgroundColor:commentSetting?.theme?.backgroundColor
                            }}
                            onClick={onOpenRegisterIframe}
                            className='cursor-pointer min-w-[85%] sm:min-w-0 text-white 
                            font-arial font-semibold font-weight-none sm:font-notosans-bold px-[30px] py-[10px] '>
                            {t('message.overlayInput.register')}
                        </button>
                    </div>
                    <div
                        className='flex mx-[10px] sm:mx-0 sm:justify-center mt-[8px] 
                                     sm:mt-[15px] text-gray-300 underline '>
                        <button
                            onClick={() => onOpenCommentNotLogin(true)}
                            className='cursor-pointer text-left sm:text-center sm:mx-auto '>
                           {t('message.overlayInput.notLogin')}
                        </button>
                    </div>
                </div>
            </div>
            {/* icon close */}
            <div
                onClick={() => {
                    onOpenAndCloseOverlayOptions(false, false)
                }}
                className='comment__active-closeBox cursor-pointer group top-[5px] right-[10px] absolute'>
                <i className='fa fa-times text-white'></i>
            </div>
        </div>
    );
};

export default PopupOption;
